enum EAction {
  'CONFIRM',
  'DEFAULT',
  'MESSAGE',
  'VALIDATION'
}

export type TAction = keyof typeof EAction;

enum EInput {
  // 'ADDRESS',
  // 'BIRTHDAY',
  'TYPE_MOBILITY',
  'CIVIL_STATUS',
  'EMERGENCY_CONTACT',
  'DEFAULT',
  // 'DNI',
  'EMAIL',
  'PHONE'
}

enum EInput2 {
  'EMAIL',
  'PHONE',
  'DEFAULT'
}

export type TInput = keyof typeof EInput;
export type TInput2 = keyof typeof EInput2;

enum EStatus {
  'DEFAULT',
  'ERROR',
  'FINISH',
  'SUCCESS'
}

export type TStatus = keyof typeof EStatus;

export type TActionState = {
  action: TAction;
  code: string;
  input: TInput;
  newValue: string;
  oldValue: string | string[];
  status: TStatus;
  requests: any;
};

export type TActionState2 = {
  action: TAction;
  code: string;
  input: TInput2;
  newValue: string;
  oldValue: string | string[];
  status: TStatus;
  requests: any;
};

export const initialActionState: TActionState = {
  action: 'DEFAULT',
  code: '',
  input: 'DEFAULT',
  newValue: '',
  oldValue: '',
  status: 'DEFAULT',
  requests: {}
};
